import { t } from '@lingui/macro'
import { formatDateAndTimeLong } from '../../../utils/dateHelpers'
import { ISearchCsvResponse } from './DownloadSearchCSV'

export const prepareCSVSearchExport = (data) =>
  data.map((row: ISearchCsvResponse) => ({
    [t`Search term`]: row.search_term,
    [t`Count`]: row.count,
    [t`Average results`]: row.avg_results || 0,
    [t`Last searched`]: formatDateAndTimeLong(row.last_searched)
  }))
